import React, { useState } from 'react';
import { Popover, List, ListItem, ListItemText } from '@material-ui/core';
import styled, { css } from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';
import { isMobile } from 'react-device-detect';
import { connect } from 'react-redux';
import {deleteSchedule} from '../../../store/actions/UserAction';

const useStyles = makeStyles({
  popper: {
    width: 130,
    margin: '0 24px 0 0',
    boxShadow: isMobile ? 'initial' : '0 2px 5px 0 rgba(0, 0, 0, 0.2)',
    backgroundColor: isMobile ? 'initial' : '#f5f5f5',
  },
  paper: {
    maxWidth: '100%',
  },
  list: {
    width: 130,
    backgroundColor: 'white',
    padding: 0,
  },
  listItem: {
    '&:hover': {
      backgroundColor: '#f5f5f5',
    },
  },
  gutters: {
    paddingRight: 0,
  },
  listItemText: {
    color: '#484848',
    fontSize: 14,
  },
});

const clock = '/img/icons/clock.svg';

// const continuousData = [
//   { day: 'Lunes', open: true, start: '00:00', end: '00:00' },
//   { day: 'Martes', open: true, start: '00:00', end: '00:00' },
//   { day: 'Miércoles', open: true, start: '00:00', end: '00:00' },
//   { day: 'Jueves', open: true, start: '00:00', end: '00:00' },
//   { day: 'Viernes', open: true, start: '00:00', end: '00:00' },
//   { day: 'Sábado', open: true, start: '00:00', end: '00:00' },
//   { day: 'Domingo', open: false, start: '00:00', end: '00:00' },
// ];

// const dividedData = [
//   {
//     day: 'Lunes',
//     open: true,
//     morning: { start: '00:00', end: '00:00' },
//     evening: { start: '00:00', end: '00:00' },
//   },
//   {
//     day: 'Martes',
//     open: true,
//     morning: { start: '00:00', end: '00:00' },
//     evening: { start: '00:00', end: '00:00' },
//   },
//   {
//     day: 'Miércoles',
//     open: true,
//     morning: { start: '00:00', end: '00:00' },
//     evening: { start: '00:00', end: '00:00' },
//   },
//   {
//     day: 'Jueves',
//     open: true,
//     morning: { start: '00:00', end: '00:00' },
//     evening: { start: '00:00', end: '00:00' },
//   },
//   {
//     day: 'Viernes',
//     open: true,
//     morning: { start: '00:00', end: '00:00' },
//     evening: { start: '00:00', end: '00:00' },
//   },
//   {
//     day: 'Sábado',
//     open: true,
//     morning: { start: '00:00', end: '00:00' },
//     evening: { start: '00:00', end: '00:00' },
//   },
//   {
//     day: 'Domingo',
//     open: false,
//     morning: { start: '00:00', end: '00:00' },
//     evening: { start: '00:00', end: '00:00' },
//   },
// ];

const Title = styled.div`
  display: flex;
  align-items: center;
`;

const DayName = styled.span`
  color: #484848;
  font-weight: bold;
  width: 113px;
  margin-bottom: 24px;
`;

const EveningSpan = styled.span`
  color: #484848;
  margin-bottom: 29px;
  padding-left: 20px;
  margin-left: 20px;
  border-left: 1px solid #35b9b6;
  text-align: center;
  width: 152px;
  @media (max-width: 1007px) {
    padding-left: 0;
    margin-left: 0;
    border-left: none;
    text-align: initial;
    width: 172px;
    display: block;
  }

  ${(props) =>
    props.smallView &&
    css`
      padding-left: 0;
      margin-left: 0;
      border-left: none;
      text-align: initial;
      width: 172px;
      display: block;
    `}
`;

const DividedContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  @media (max-width: 1007px) {
    display: initial;
  }
  ${(props) =>
    props.smallView &&
    css`
      padding-left: 0;
      margin-left: 0;
      border-left: none;
      text-align: initial;
      width: 172px;
      display: block;
    `}
`;

const CloseDivided = styled.span`
  color: #484848;
  margin-bottom: 29px;
  padding-left: 20px;
  margin-left: 20px;
  border-left: 1px solid #35b9b6;
  text-align: center;
  width: 152px;
  @media (max-width: 1007px) {
    display: none;
  }
  ${(props) =>
    props.smallView &&
    css`
      display: none;
    `}
`;

const Button = styled.button`
  background-color: transparent;
  outline: none;
  cursor: pointer;
  border: none;
  -webkit-tap-highlight-color: transparent;
`;

// const weekDays = [
//   'Lunes',
//   'Martes',
//   'Miércoles',
//   'Jueves',
//   'Viernes',
//   'Sábado',
//   'Domingo',
// ];

const ScheduleView = ({
  smallView,
  optionsButton,
  authClient,
 // scheduleType,
 // scheduleDays,
  editSchedule,
  deleteSchedule,
  uid,
  publicSchedule,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const classes = useStyles();

  const openPopper = Boolean(anchorEl);
  const handlePopper = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleDelete = () => {
    console.log('eliminar')
    deleteSchedule(uid, false)
  };

  const authScheduleType = authClient.schedule && authClient.schedule.type;
  const authScheduleDays = authClient.schedule && authClient.schedule.scheduleDays;

  const scheduleType = publicSchedule? publicSchedule.type : authScheduleType;
  const arraySchedule = publicSchedule? (Object.entries(publicSchedule.scheduleDays)) : (authScheduleDays && Object.entries(authScheduleDays));
  
  const order = {
    Lunes: 1,
    Martes: 2,
    Miércoles: 3,
    Jueves: 4,
    Viernes: 5,
    Sábado: 6,
    Domingo: 7,
  };

  arraySchedule && arraySchedule.sort((a, b) => order[a[0]] - order[b[0]]);

  return (
    <>
      <div style={{ width: '100%' }}>
        <div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              width: '100%',
              alignItems: 'center',
              marginBottom: 17,
            }}
          >
            <Title>
              <img
                src={clock}
                style={{ width: 24, height: 24, marginRight: 8 }}
                alt='clock'
              />
              <span
                style={{ color: '#013957', fontSize: 18, fontWeight: 'bold' }}
              >
                Horarios de atención
              </span>
            </Title>
            {optionsButton && (
              <Button onClick={handlePopper}>
                <img src="/img/expand/menu-options.svg" alt="opciones" />
              </Button>
            )}
          </div>
          <div style={{ marginLeft: 32 }}>
            {scheduleType === 'continuous' && (
              <>
                {arraySchedule.map((item, index) => {
                  return (
                    <div key={index} style={{ display: 'flex' }}>
                      <DayName>{item[0]}</DayName>
                      {item[1].open ? (
                        <span
                          style={{ color: '#484848' }}
                        >{`${item[1].start} hr - ${item[1].end} hr`}</span>
                      ) : (
                        <div
                          style={{ width: 130.9, height: 19, display: 'flex' }}
                        >
                          <span style={{ color: '#484848', margin: '0 auto' }}>
                            Cerrado
                          </span>
                        </div>
                      )}
                    </div>
                  );
                })}
              </>
            )}

            {scheduleType === 'divided' && (
              <>
                {arraySchedule.map((item, index) => {
                  return (
                    <div key={index} style={{ display: 'flex' }}>
                      <DayName>{item[0]}</DayName>
                      {item[1].open ? (
                        <DividedContainer smallView={smallView}>
                          <span
                            style={{ color: '#484848' }}
                          >{`${item[1].morning.start} hr - ${item[1].morning.end} hr`}</span>

                          {item[1].evening.start? 
                            <EveningSpan smallView={smallView}>
                            {`${item[1].evening.start} hr - ${item[1].evening.end} hr`}
                          </EveningSpan> : <div style={{height: 18.4, marginBottom: 29}}></div>
                          }

                        </DividedContainer>
                      ) : (
                        <div style={{ display: 'flex' }}>
                          <span
                            style={{
                              color: '#484848',
                              minWidth: 130,
                              textAlign: 'center',
                            }}
                          >
                            Cerrado
                          </span>
                          <CloseDivided smallView={smallView}>
                            Cerrado
                          </CloseDivided>
                        </div>
                      )}
                    </div>
                  );
                })}
              </>
            )}
          </div>
        </div>
      </div>
      <Popover
        open={openPopper}
        anchorEl={anchorEl}
        //className={classes.popper}
        onClose={() => setAnchorEl(null)}
        classes={{ paper: classes.paper }}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'right',
        }}
      >
        <List
          className={classes.list}
          component="nav"
          aria-label="secondary mailbox folders"
        >
          <ListItem className={classes.listItem} button>
            <ListItemText
              onClick={editSchedule}
              className={classes.listItemText}
              primary="Editar horario"
              disableTypography
            />
          </ListItem>

          <ListItem
            className={classes.listItem}
            button
            classes={{ gutters: classes.gutters }}
          >
            <ListItemText
              onClick={handleDelete}
              className={classes.listItemText}
              primary="Eliminar horario"
              disableTypography
            />
          </ListItem>
        </List>
      </Popover>
    </>
  );
};

const mapStateToProps = (state) => ({
  uid: state.authClient.uid,
  authClient: state.authClient,
  //scheduleType: state.authClient.schedule && state.authClient.schedule.type,
  //scheduleDays: state.authClient.schedule && state.authClient.schedule.scheduleDays,
});

const mapDispatchToProps = dispatch => ({
  deleteSchedule: (uid, boolValues) => dispatch(deleteSchedule(uid, boolValues))
});

export default connect(mapStateToProps, mapDispatchToProps)(ScheduleView);
